import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { DataDomain } from 'reportViewer'

export const useDataDomain = (): DataDomain => {
    const [domain, setDomain] = useState<DataDomain>('compounds')
    const { pathname } = useLocation()

    useEffect(() => {
        setDomain(pathname.split('/')[1] as DataDomain)
    }, [pathname])

    return domain
}
